/* eslint-disable react/prop-types */
//@ts-check
import React from 'react';
import Formatter from '../../../formatter';

var getDisplayName = function getDisplayName(data) {
  return data.DisplayName || data.UserName;
};
/**@type {import('../types').DataType<import('./types').UserModel>} */


var USER_DATA_TYPE = {
  data: {
    url: '/backend/users',
    itemUrl: '/backend/users?userName={id}',
    deleteItemUrl: '/backend/users?userName={id}',
    createItemUrl: {
      url: '/backend/users2',
      contentType: 'multipart'
    },
    updateItemUrl: {
      url: '/backend/users2?userName={id}',
      contentType: 'multipart'
    },
    dataKey: 'user',
    idKeyProp: 'UserName',
    filterUrlKey: 'Query'
  },
  placeholders: {
    type: function type() {
      return 'user';
    },
    label: function label(data) {
      return getDisplayName(data);
    }
  },
  columns: [{
    id: 'Name',
    children: 'Name',
    formatter: function NameFormatter(_ref) {
      var data = _ref.data;
      return React.createElement(Formatter.Link, {
        icon: "user",
        text: getDisplayName(data),
        value: "/EOS/users/".concat(data.Id)
      });
    } //inMemorySort: data => data.UserName,

  }, {
    id: 'Email',
    formatter: function EmailFormatter(_ref2) {
      var data = _ref2.data;
      return React.createElement(Formatter.Text, {
        value: data.Email
      });
    } //inMemorySort: data => data.Email,

  }, {
    id: 'Enabled',
    formatter: function EnabledFormatter(_ref3) {
      var data = _ref3.data;
      return React.createElement(Formatter.Switch, {
        value: data.Enabled
      });
    } //inMemorySort: data => data.Enabled,

  }, {
    id: 'LastLogIn',
    formatter: function LastLoginFormatter(_ref4) {
      var data = _ref4.data;
      return React.createElement(Formatter.Text, {
        value: data.LastLogIn
      });
    } //inMemorySort: data => data.LastLogIn,

  }, {
    id: 'Groups',
    formatter: function GroupsFormatter(_ref5) {
      var data = _ref5.data;
      return React.createElement(React.Fragment, null, data.Groups.map(function (g) {
        return React.createElement(Formatter.Text, {
          key: g.Id,
          value: g.Name
        });
      }));
    } //inMemorySort: data => data.LastLogIn,

  }, {
    id: 'ApiKeys',
    formatter: function ApiKeysFormatter(_ref6) {
      var data = _ref6.data;
      return React.createElement(React.Fragment, null, data.ApiKeys.map(function (apiKey) {
        return React.createElement(Formatter.Text, {
          key: apiKey.Token,
          value: apiKey.Reason
        });
      }));
    } //inMemorySort: data => data.LastLogIn,

  }],
  thumbnail: {
    text: function text(data) {
      return getDisplayName(data);
    },
    icon: function icon() {
      return 'user';
    }
  },
  contextMenu: [{
    label: 'Open'
  }, 'separator', {
    type: 'delete'
  }]
};
export default USER_DATA_TYPE;